(function unitOrgControlModuleDefinition() {
    'use strict';

    angular.module('UnitOrgControl', ['angucomplete-alt', 'angucompleteExtend'])
        .directive('crUnitOrgControl', ['$translate', 'organizationalUnitService', 'userService', 'errorsExtend', 'authExtend',
            function ($translate, organizationalUnitService, userService, errors, auth) {
                return {
                    scope: {
                        unitOrgId: '=',
                        unitOrgName: '=',
                        required: '@',
                        tabindex: '@',
                        labelName: '@',
                        allOu: '@',
                        unitOrgNotInId: '=',
                        placeholder: '@',
                        securityLevelConfig: '=',
                        allForUser: '@',
                        callBack: '&onSelected',
                        options: '=',
                        disableInput: '='
                    },

                    controller: [
                        '$scope', '$element', function ($scope, $element) {
                            $scope.init = function () {
                                $scope.typedLength = 0;
                                $scope.parents = [];
                                $scope.inputValue = '';
                                $scope.afterLostFocus = false;

                                //if (!$scope.labelName)
                                //    $scope.label = 'OUDirective';
                                //else
                                //    $scope.label = $scope.labelName;
                            };

                            $scope.clear = function () {
                                //https://github.com/ghiden/angucomplete-alt
                                //Clear Input
                                $scope.$broadcast('angucomplete-alt:clearInput');
                                $scope.typedLength = 0;
                                $scope.parents = [];
                                $scope.unitOrgId = undefined;
                                $scope.unitOrgName = undefined;
                                $scope.afterLostFocus = false;
                                $scope.inputValue = '';
                            }

                            $scope.match = function () {
                                if ($scope.typedLength < 3 || $scope.parents.length === 0)
                                    return -1;

                                for (var i = 0; i < $scope.parents.length; i++) {
                                    if ($scope.parents.hasOwnProperty(i)) {
                                        if ($scope.parents[i].name.toUpperCase().lastIndexOf($scope.inputValue, 0) >= 0) {
                                            return i;
                                        }
                                    }
                                };
                                return -1;
                            }

                            $scope.selectedOU = function (selected) {
                                if (selected) {
                                    $scope.callBack({ selected: selected.originalObject });
                                    $scope.unitOrgId = selected.originalObject.id;
                                    $scope.unitOrgName = selected.originalObject.name;
                                    $scope.securityLevelConfig = selected.originalObject.securityLevelConfig;
                                } else {
                                    if ($scope.afterLostFocus) {
                                        $scope.afterLostFocus = false;
                                        //Sale del control y no eligio nada
                                        $scope.clear();
                                    } else {
                                        //Esta borrando lo elegido
                                        $scope.unitOrgId = undefined;
                                        $scope.unitOrgName = undefined;

                                    }
                                }

                            };

                            $scope.focusIn = function () {
                                $scope.afterLostFocus = false;
                            }

                            $scope.lostFocus = function () {
                                $scope.afterLostFocus = true;
                                if (!$scope.unitOrgId) {
                                    var index = $scope.match();
                                    if (~index) {
                                        $scope.unitOrgId = $scope.parents[index].id;
                                        $scope.unitOrgName = $scope.parents[index].name;
                                    } else {
                                        $scope.clear();
                                    }
                                }
                            }

                            $scope.updateOU = function (typed) {
                                if (typed)
                                    $scope.inputValue = typed.toUpperCase();
                                else
                                    $scope.inputValue = typed;

                                $scope.unitOrgId = undefined;

                                var typedLength = String(typed).length;
                                if (Math.abs($scope.typedLength - typedLength) === 1) {
                                    $scope.typedLength = typedLength;
                                    if (typedLength !== 3) {
                                        return;
                                    }
                                } else {
                                    $scope.typedLength = typedLength;
                                    if (typedLength < 3) {
                                        return;
                                    }
                                }

                                if (!$scope.allForUser) {
                                    organizationalUnitService.get(typed, $scope.unitOrgNotInId, $scope.allOu).then(function getOk(result) {
                                        $scope.parents = result;
                                        $scope.tempParents = result;
                                    }, function getError(error) {
                                        errors.showError(error);
                                    });
                                }
                                else {
                                    userService.getAllForUser(typed).then(function getOk(result) {
                                        var ous = [];
                                        result.forEach(function (element) {
                                            element.name = element.organizationalUnit.name;
                                            ous.push(element);
                                        });
                                        $scope.parents = ous;
                                        $scope.tempParents = ous;
                                    }, function getError(error) {
                                        errors.showError(error);
                                    });
                                }
                            };

                            $scope.init();
                        }],
                    restrict: 'A',
                    templateUrl: '/app/directives/unit-org-control/unit-org-control.html',
                    link: function ($scope) {
                        if ($scope.options) {
                            angular.extend($scope.options, {
                                clearInput: function () {
                                    $scope.$broadcast('angucomplete-alt:clearInput');
                                }
                            });
                        }
                    }
                };
            }
        ]);
})();